/**
 * Length and beam, the two numbers a boat document already carries.
 * Drawing and seat size use this. The boat-collision module is the only
 * thing that turns the pair into a capsule.
 */
import { BOAT_LENGTH_M, PIXELS_PER_METER } from './constants.ts';

export type HullDimensions = {
  lengthM: number;
  beamM: number;
};

/** The factory skiff, for a caller that has no boat document to hand. */
export const DEFAULT_HULL: HullDimensions = {
  lengthM: BOAT_LENGTH_M,
  beamM: BOAT_LENGTH_M / 2,
};

/**
 * Share of the drawn hull that counts for boat-to-boat contact. Below 1 so two hulls can brush
 * past each other the way they look like they should; the picture stays full size.
 */
export const HULL_CONTACT_SCALE = 0.85;

/** The contact capsule's half spine and half beam, in world pixels. */
export function contactShape(dimensions: HullDimensions): { halfSpine: number; radius: number } {
  const lengthPx = dimensions.lengthM * PIXELS_PER_METER * HULL_CONTACT_SCALE;
  const beamPx = dimensions.beamM * PIXELS_PER_METER * HULL_CONTACT_SCALE;

  return {
    halfSpine: Math.max(lengthPx - beamPx, 0) / 2,
    radius: Math.max(beamPx / 2, 1e-9),
  };
}
